import React from 'react';
import './buttonText.css';

interface TextButtonProps {
    onClick: () => void;
    disabled?: boolean;
    isSubmitting?: boolean;
    buttonColor?: "blue" | "red";
    buttonText?: string;
    buttonStyle?: "default" | "modern";
}

const TextButton: React.FC<TextButtonProps> = ({
    onClick,
    disabled = false,
    isSubmitting = false,
    buttonColor = "blue",
    buttonText,
    buttonStyle = "default",
}) => {
    const isButtonDisabled = disabled || isSubmitting;

    const buttonTypeClass = `textButton-${buttonColor}`;
    const buttonStyleClass = `textButton-${buttonStyle}`;

    return (
        <button 
            className={`textButton-main ${!isButtonDisabled ? 'enabled' : ''} ${buttonTypeClass} ${buttonStyleClass}`}
            disabled={isButtonDisabled}
            onClick={onClick}
        >
            {buttonText}
        </button>
    );
};

export default TextButton;